import React from 'react'

import DynamicModuleLoaderComponent from '../sharedLegacy/components/DynamicModuleLoaderComponent/DynamicModuleLoaderComponent'
import { AudienceAppComponent } from '../WebinarAudienceRoom/components/AudienceAppComponent/AudienceAppComponent'
import webinarAudienceModule from '../WebinarAudienceRoom'
import { AudienceAppStateProvider } from '../WebinarAudienceRoom/providers/AudienceAppStateProvider'

const modules = [webinarAudienceModule]

const WebinarAudienceRoomRoutesComponent = () => {
  return (
    <DynamicModuleLoaderComponent modules={modules}>
      <AudienceAppStateProvider
        liveId={window.LIVE_ID}
        liveToken={window.LIVE_TOKEN}
      >
        <AudienceAppComponent />
      </AudienceAppStateProvider>
    </DynamicModuleLoaderComponent>
  )
}

export { WebinarAudienceRoomRoutesComponent }
